// import React from "react";
// import { useForm } from "react-hook-form";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import logo from '../assets/rem-logo.png';

// const Careers = () => {
//     const {
//         register,
//         handleSubmit,
//         formState: { errors },
//     } = useForm();

//     const onSubmit = (data) => {
//         console.log("Form Data Submitted: ", data);
//         alert("Form submitted successfully!");
//     };


//     const handleSubmit = (e) => {
//         e.preventDefault();
//         if (validate()) {
//             console.log("Form submitted successfully:", formData);
//             setSubmissionStatus("Submitting...");

//             // Simulate form submission (replace with actual submission logic)
//             setTimeout(() => {
//                 setSubmissionStatus("Thanks for contacting us! We will get back to you soon.");
//                 setTimeout(() => {
//                     setSubmissionStatus(""); // Clear the status message after 5 seconds
//                 }, 5000);

//                 // Reset the form by clearing the state
//                 setFormData({
//                     name: "",
//                     mobile: "",
//                     email: "",
//                     subject: "",
//                     message: "",
//                 });
//             }, 1000);
//         } else {
//             console.log("Form contains errors:", errors);
//             setSubmissionStatus("Please fill out the form correctly.");
//         }
//     };


//     return (
//         <>

//             <Navbar />
//             {/* Hero Section */}
//             <section className="bg-gray-100 py-12">
//                 <div className="container mx-auto flex flex-col lg:flex-row items-center">
//                     <div className="lg:w-1/2 text-center lg:text-left">
//                         {/* <img
//                             src={logo}
//                             alt="Logo"
//                             className="w-32 mx-auto lg:mx-0 mb-6 lg:mb-0 bg-purple-700 items-center content-center h-100 w-100"
//                         /> */}
//                         <h1 className="text-4xl font-bold text-purple-700 mb-4">
//                             Discover your new career
//                         </h1>
//                         <p className="text-gray-600 text-lg mb-6">
//                             Explore opportunities
//                         </p>
//                         <div className="flex justify-center lg:justify-start space-x-4">
//                             <a
//                                 href="#form"
//                                 className="bg-purple-600 text-white px-6 py-2 rounded-md shadow-md hover:bg-purple-700"
//                             >
//                                 SEARCH JOBS
//                             </a>
//                             <a
//                                 href="#"
//                                 className="bg-gray-200 text-purple-600 px-6 py-2 rounded-md shadow-md hover:bg-gray-300"
//                             >
//                                 RECENTLY VIEWED JOBS
//                             </a>
//                         </div>
//                     </div>
//                     <div className="lg:w-1/2 mt-4">
//                         {/* <img
//                             src="https://i.pinimg.com/originals/67/6d/00/676d00c7e93b286babffba7590cc4e26.jpg"
//                             alt="Career"
//                             className="rounded-lg shadow-md"
//                         /> */}
//                         <img src={logo} className="bg-purple-800 rounded-2xl" />
//                     </div>
//                 </div>
//             </section>

//             {/* Warning Section */}
//             <section className="bg-purple-100 py-6">
//                 <div className="container mx-auto text-center">
//                     <p className="text-gray-700 text-justify p-4">
//                         We have been alerted to the existence of fraudulent messages asking job seekers to set up
//                         payment to cover various costs associated with establishing employment at Powergenic
//                         Engineering. No one is ever required to pay for employment at Powergenic Engineering. If
//                         you are contacted by someone asking for payment, please do not respond, and contact us at{" "}
//                         <a
//                             href="mailto:sales.powergenic@gmail.com"
//                             className="text-purple-700 underline"
//                         >
//                             sales.powergenic@gmail.com
//                         </a>{" "}
//                         immediately.
//                     </p>
//                 </div>
//             </section>

//             {/* Contact Form Section */}
//             <section className="py-12 bg-gray-50" id="form">
//                 <div className="container mx-auto">
//                     <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-lg p-8">
//                         <h2 className="text-2xl font-bold text-purple-700 mb-6">
//                             Apply for a Job
//                         </h2>
//                         <form onSubmit={handleSubmit} id="form">
//                             {/* Name and Email */}
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                                 <div>
//                                     <input
//                                         type="text"
//                                         name="name"
//                                         {...register("name", { required: "Name is required" })}
//                                         placeholder="Your Name *"
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.name && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.name.message}
//                                         </span>
//                                     )}
//                                 </div>
//                                 <div>
//                                     <input
//                                         type="email"
//                                         name="email"
//                                         {...register("email", { required: "Email is required" })}
//                                         placeholder="Your Email *"
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.email && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.email.message}
//                                         </span>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Father's Name and Date of Birth */}
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                                 <div>
//                                     <input
//                                         type="text"
//                                         name="fatherName"
//                                         {...register("fatherName", { required: "Father's Name is required" })}
//                                         placeholder="Father's Name *"
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.fatherName && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.fatherName.message}
//                                         </span>
//                                     )}
//                                 </div>
//                                 <div>
//                                     <input
//                                         type="date"
//                                         name="dateOfBirth"
//                                         {...register("dob", { required: "Date of Birth is required" })}
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.dob && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.dob.message}
//                                         </span>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Qualification and Phone */}
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                                 <div>
//                                     <input
//                                         type="text"
//                                         name="qualification"
//                                         {...register("qualification", { required: "Qualification is required" })}
//                                         placeholder="Qualification *"
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.qualification && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.qualification.message}
//                                         </span>
//                                     )}
//                                 </div>
//                                 <div>
//                                     <input
//                                         type="tel"
//                                         name="phone"
//                                         {...register("phone", {
//                                             required: "Phone number is required",
//                                             pattern: {
//                                                 value: /^[0-9]{10,12}$/,
//                                                 message: "Enter a valid phone number",
//                                             },
//                                         })}
//                                         placeholder="Phone Number *"
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.phone && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.phone.message}
//                                         </span>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Skills and Resume Link */}
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                                 <div>
//                                     <input
//                                         type="text"
//                                         name="skills"
//                                         {...register("skills", { required: "Skills are required" })}
//                                         placeholder="Skills *"
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.skills && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.skills.message}
//                                         </span>
//                                     )}
//                                 </div>
//                                 <div>
//                                     <input
//                                         type="url"
//                                         name="resume"
//                                         {...register("resume", { required: "Resume link is required" })}
//                                         placeholder="Resume Link *"
//                                         className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                     />
//                                     {errors.resume && (
//                                         <span className="text-red-500 text-sm">
//                                             {errors.resume.message}
//                                         </span>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Message */}
//                             <div className="mb-4">
//                                 <textarea
//                                 name="message"
//                                     {...register("message", { required: "Message is required" })}
//                                     placeholder="Your Message..."
//                                     rows="5"
//                                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                                 />
//                                 {errors.message && (
//                                     <span className="text-red-500 text-sm">
//                                         {errors.message.message}
//                                     </span>
//                                 )}
//                             </div>

//                             {/* Submit Button */}
//                             <button
//                                 type="submit"
//                                 className="w-full bg-purple-600 text-white py-3 rounded-md hover:bg-purple-700"
//                             >
//                                 Submit
//                             </button>
//                         </form>
//                     </div>
//                 </div>
//             </section>

//             <Footer />
//         </>
//     );
// };

// export default Careers;








// import React, { useState } from "react";
// import { useForm } from "react-hook-form";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import logo from "../assets/rem-logo.png";
// import axios from 'axios';

// const Careers = () => {
//   const {
//     register,
//     // handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm();

//   // const [submissionStatus, setSubmissionStatus] = useState("");

//   // const onSubmit = (data) => {
//   //   console.log("Form submitted successfully:", data);
//   //   setSubmissionStatus("Submitting...");

//   //   // Simulate form submission (replace with actual submission logic)
//   //   setTimeout(() => {
//   //     setSubmissionStatus("Thanks for contacting us! We will get back to you soon.");
//   //     setTimeout(() => setSubmissionStatus(""), 5000);

//   //     // Reset the form
//   //     reset();
//   //   }, 1000);
//   // };




//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [fatherName, setFatherName] = useState("");
//   const [dob, setDob] = useState("");
//   const [qualification, setQualification] = useState("");
//   const [phone, setPhone] = useState("");
//   const [skills, setSkills] = useState("");
//   const [resume, setResume] = useState("");
//   const [message, setMessage] = useState("");
//   const [submissionStatus, setSubmissionStatus] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const data = {
//       Name: name,
//       Email: email,
//       FatherName: fatherName,
//       DOB: dob,
//       Qualification: qualification,
//       PhoneNumber: phone,
//       Skills: skills,
//       ResumeLink: resume,
//       Message: message,
//     };

//     setSubmissionStatus("Submitting...");

//     axios
//       .post(
//         "https://api.sheetbest.com/sheets/9302cdac-e5ca-4b88-bbd8-6a31f8f49ac9",
//         data
//       )
//       .then(() => {
//         setName("");
//         setEmail("");
//         setFatherName("");
//         setDob("");
//         setQualification("");
//         setPhone("");
//         setSkills("");
//         setResume("");
//         setMessage("");
//         setSubmissionStatus("Thank you for applying! We will contact you soon.");
//         setTimeout(() => setSubmissionStatus(""), 5000); // Clear message after 5 seconds
//       })
//       .catch((error) => {
//         console.error(error);
//         setSubmissionStatus("Something went wrong. Please try again later.");
//       });
//   };




//   return (
//     <>
//       <Navbar />
//       {/* Hero Section */}
//       <section className="bg-gray-100 py-12">
//         <div className="container mx-auto flex flex-col lg:flex-row items-center">
//           <div className="lg:w-1/2 text-center lg:text-left">
//             <h1 className="text-4xl font-bold text-purple-700 mb-4">
//               Discover your new career
//             </h1>
//             <p className="text-gray-600 text-lg mb-6">Explore opportunities</p>
//             <div className="flex justify-center lg:justify-start space-x-4">
//               <a
//                 href="#form"
//                 className="bg-purple-600 text-white px-6 py-2 rounded-md shadow-md hover:bg-purple-700"
//               >
//                 SEARCH JOBS
//               </a>
//               <a
//                 href="#"
//                 className="bg-gray-200 text-purple-600 px-6 py-2 rounded-md shadow-md hover:bg-gray-300"
//               >
//                 RECENTLY VIEWED JOBS
//               </a>
//             </div>
//           </div>
//           <div className="lg:w-1/2 mt-4">
//             <img src={logo} alt="Logo" className="bg-purple-800 rounded-2xl" />
//           </div>
//         </div>
//       </section>

//       {/* Warning Section */}
//       <section className="bg-purple-100 py-6">
//         <div className="container mx-auto text-center">
//           <p className="text-gray-700 text-justify p-4">
//             We have been alerted to the existence of fraudulent messages asking
//             job seekers to set up payment to cover various costs associated
//             with establishing employment at Powergenic Engineering. No one is
//             ever required to pay for employment at Powergenic Engineering. If
//             you are contacted by someone asking for payment, please do not
//             respond, and contact us at{" "}
//             <a
//               href="mailto:sales.powergenic@gmail.com"
//               className="text-purple-700 underline"
//             >
//               sales.powergenic@gmail.com
//             </a>{" "}
//             immediately.
//           </p>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section className="py-12 bg-gray-50" id="form">
//         <div className="container mx-auto">
//           <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-lg p-8">
//             <h2 className="text-2xl font-bold text-purple-700 mb-6">
//               Apply for a Job
//             </h2>
//             <form onSubmit={handleSubmit} name="submit-to-google-sheet" id="form">
//               {/* Name and Email */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"

//                     name="name"
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     {...register("name", { required: "Name is required" })}
//                     placeholder="Your Name *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.name && (
//                     <span className="text-red-500 text-sm">
//                       {errors.name.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="email"
//                     name="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     {...register("email", { required: "Email is required" })}
//                     placeholder="Your Email *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.email && (
//                     <span className="text-red-500 text-sm">
//                       {errors.email.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Father’s Name and Date of Birth */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="fatherName"
//                     value={fatherName}
//                     onChange={(e) => setFatherName(e.target.value)}
//                     {...register("fatherName", {
//                       required: "Father's Name is required",
//                     })}
//                     placeholder="Father's Name *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.fatherName && (
//                     <span className="text-red-500 text-sm">
//                       {errors.fatherName.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="date"
//                     name="dob"
//                     value={dob}
//                     onChange={(e) => setDob(e.target.value)}
//                     {...register("dob", { required: "Date of Birth is required" })}
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.dob && (
//                     <span className="text-red-500 text-sm">
//                       {errors.dob.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Qualification and Phone */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="qualification"
//                     value={qualification}
//                     onChange={(e) => setQualification(e.target.value)}
//                     {...register("qualification", {
//                       required: "Qualification is required",
//                     })}
//                     placeholder="Qualification *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.qualification && (
//                     <span className="text-red-500 text-sm">
//                       {errors.qualification.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value)}
//                     {...register("phone", {
//                       required: "Phone number is required",
//                       pattern: {
//                         value: /^[0-9]{10,12}$/,
//                         message: "Enter a valid phone number",
//                       },
//                     })}
//                     placeholder="Phone Number *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.phone && (
//                     <span className="text-red-500 text-sm">
//                       {errors.phone.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Skills and Resume */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="skills"
//                     value={skills}
//                     onChange={(e) => setSkills(e.target.value)}
//                     {...register("skills", { required: "Skills are required" })}
//                     placeholder="Skills *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.skills && (
//                     <span className="text-red-500 text-sm">
//                       {errors.skills.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="url"
//                     name="resume"
//                     value={resume}
//                     onChange={(e) => setResume(e.target.value)}
//                     {...register("resume", {
//                       required: "Resume link is required",
//                     })}
//                     placeholder="Resume Link *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.resume && (
//                     <span className="text-red-500 text-sm">
//                       {errors.resume.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Message */}
//               <div className="mb-4">
//                 <textarea
//                 name="message"
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                   {...register("message", { required: "Message is required" })}
//                   placeholder="Message *"
//                   className="w-full p-3 border rounded-md focus:outline-purple-600"
//                 />
//                 {errors.message && (
//                   <span className="text-red-500 text-sm">
//                     {errors.message.message}
//                   </span>
//                 )}
//               </div>

//               {/* Submit Button */}
//               <div className="text-center">
//                 <button
//                   type="submit"
//                   className="bg-purple-600 text-white px-6 py-3 rounded-md shadow-md hover:bg-purple-700"
//                 >
//                   {submissionStatus || "Send Message"}
//                 </button>
//                 {/* {submissionStatus && (
//                   <p className="text-green-600 mt-4">{submissionStatus}</p>
//                 )} */}
//               </div>
//             </form>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default Careers;










// import React, { useState } from "react";
// import { useForm } from "react-hook-form";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import logo from "../assets/rem-logo.png";
// import axios from 'axios';

// const Careers = () => {
//   // const {
//   //   register,
//   //   reset,
//   //   formState: { errors },
//   // } = useForm();

//   const [errors, setErrors] = useState({});

//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [fatherName, setFatherName] = useState("");
//   const [dob, setDob] = useState("");
//   const [qualification, setQualification] = useState("");
//   const [phone, setPhone] = useState("");
//   const [skills, setSkills] = useState("");
//   const [resume, setResume] = useState("");
//   const [message, setMessage] = useState("");
//   const [submissionStatus, setSubmissionStatus] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const data = {
//       Name: name,
//       Email: email,
//       FatherName: fatherName,
//       DOB: dob,
//       Qualification: qualification,
//       PhoneNumber: phone,
//       Skills: skills,
//       ResumeLink: resume,
//       Message: message,
//     };

//     setSubmissionStatus("Submitting...");

//     axios
//       .post(
//         "https://api.sheetbest.com/sheets/9302cdac-e5ca-4b88-bbd8-6a31f8f49ac9",
//         data
//       )
//       .then(() => {
//         setName("");
//         setEmail("");
//         setFatherName("");
//         setDob("");
//         setQualification("");
//         setPhone("");
//         setSkills("");
//         setResume("");
//         setMessage("");
//         setSubmissionStatus("Thank you for applying! We will contact you soon.");
//         setTimeout(() => setSubmissionStatus(""), 5000); // Clear message after 5 seconds
//       })
//       .catch((error) => {
//         console.error(error);
//         setSubmissionStatus("Something went wrong. Please try again later.");
//       });
//   };

//   return (
//     <>
//       <Navbar />
//       {/* Hero Section */}
//       <section className="bg-gray-100 py-12">
//         <div className="container mx-auto flex flex-col lg:flex-row items-center">
//           <div className="lg:w-1/2 text-center lg:text-left">
//             <h1 className="text-4xl font-bold text-purple-700 mb-4">
//               Discover your new career
//             </h1>
//             <p className="text-gray-600 text-lg mb-6">Explore opportunities</p>
//             <div className="flex justify-center lg:justify-start space-x-4">
//               <a
//                 href="#form"
//                 className="bg-purple-600 text-white px-6 py-2 rounded-md shadow-md hover:bg-purple-700"
//               >
//                 SEARCH JOBS
//               </a>
//               <a
//                 href="#"
//                 className="bg-gray-200 text-purple-600 px-6 py-2 rounded-md shadow-md hover:bg-gray-300"
//               >
//                 RECENTLY VIEWED JOBS
//               </a>
//             </div>
//           </div>
//           <div className="lg:w-1/2 mt-4">
//             <img src={logo} alt="Logo" className="bg-purple-800 rounded-2xl" />
//           </div>
//         </div>
//       </section>

//       {/* Warning Section */}
//       <section className="bg-purple-100 py-6">
//         <div className="container mx-auto text-center">
//           <p className="text-gray-700 text-justify p-4">
//             We have been alerted to the existence of fraudulent messages asking
//             job seekers to set up payment to cover various costs associated
//             with establishing employment at Powergenic Engineering. No one is
//             ever required to pay for employment at Powergenic Engineering. If
//             you are contacted by someone asking for payment, please do not
//             respond, and contact us at{" "}
//             <a
//               href="mailto:sales.powergenic@gmail.com"
//               className="text-purple-700 underline"
//             >
//               sales.powergenic@gmail.com
//             </a>{" "}
//             immediately.
//           </p>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section className="py-12 bg-gray-50" id="form">
//         <div className="container mx-auto">
//           <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-lg p-8">
//             <h2 className="text-2xl font-bold text-purple-700 mb-6">
//               Apply for a Job
//             </h2>
//             <form onSubmit={handleSubmit} name="submit-to-google-sheet" id="form">
//               {/* Name and Email */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="name"
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     required= "Name is required" 
//                     placeholder="Your Name *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.name && (
//                     <span className="text-red-500 text-sm">
//                       {errors.name.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="email"
//                     name="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required= "Email is required"
//                     placeholder="Your Email *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.email && (
//                     <span className="text-red-500 text-sm">
//                       {errors.email.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Father’s Name and Date of Birth */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="fatherName"
//                     value={fatherName}
//                     onChange={(e) => setFatherName(e.target.value)}

//                     required= "Father's Name is required"
//                     placeholder="Father's Name *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.fatherName && (
//                     <span className="text-red-500 text-sm">
//                       {errors.fatherName.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="date"
//                     name="dob"
//                     value={dob}
//                     onChange={(e) => setDob(e.target.value)}
//                      required= "Date of Birth is required"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.dob && (
//                     <span className="text-red-500 text-sm">
//                       {errors.dob.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Qualification and Phone */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="qualification"
//                     value={qualification}
//                     onChange={(e) => setQualification(e.target.value)}

//                       required= "Qualification is required"

//                     placeholder="Qualification *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.qualification && (
//                     <span className="text-red-500 text-sm">
//                       {errors.qualification.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value)}

//                     required= "Phone number is required"
//                     placeholder="Phone Number *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.phone && (
//                     <span className="text-red-500 text-sm">
//                       {errors.phone.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Skills and Resume */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="skills"
//                     value={skills}
//                     onChange={(e) => setSkills(e.target.value)}
//                      required= "Skills are required"
//                     placeholder="Skills *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.skills && (
//                     <span className="text-red-500 text-sm">
//                       {errors.skills.message}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <input
//                     type="url"
//                     name="resume"
//                     value={resume}
//                     onChange={(e) => setResume(e.target.value)}

//                       required= "Resume link is required"
//                     placeholder="Resume Link *"
//                     className="w-full p-3 border rounded-md focus:outline-purple-600"
//                   />
//                   {errors.resume && (
//                     <span className="text-red-500 text-sm">
//                       {errors.resume.message}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Message */}
//               <div className="mb-4">
//                 <textarea
//                   name="message"
//                   value={message}
//                   onChange={(e) => setMessage(e.target.value)}
//                   placeholder="Message"
//                   className="w-full p-3 border rounded-md focus:outline-purple-600"
//                 ></textarea>
//               </div>

//               {/* Submission Status */}
//               {submissionStatus && (
//                 <p className="text-center text-purple-600 mb-4">
//                   {submissionStatus}
//                 </p>
//               )}

//               {/* Submit Button */}
//               <button
//                 type="submit"
//                 className="w-full bg-purple-600 text-white py-3 rounded-md hover:bg-purple-700 transition duration-200"
//               >
//                 Submit
//               </button>
//             </form>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default Careers;



import React, { useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import logo from "../assets/rem-logo.png";
import jobLogo from "../assets/job.png";

const Careers = () => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    fatherName: "",
    dob: "",
    qualification: "",
    phone: "",
    skills: "",
    resume: "",
    message: "",
  });
  const [submissionStatus, setSubmissionStatus] = useState("");

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear errors when the input changes
  };

  // Validate form inputs
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Valid email is required.";
    if (!formData.fatherName.trim()) newErrors.fatherName = "Father's Name is required.";
    if (!formData.dob) newErrors.dob = "Date of Birth is required.";
    if (!formData.qualification.trim()) newErrors.qualification = "Qualification is required.";
    if (!formData.phone.trim() || !/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Valid 10-digit phone number is required.";
    if (!formData.skills.trim()) newErrors.skills = "Skills are required.";
    if (!formData.resume.trim() || !/^https?:\/\/.+/.test(formData.resume))
      newErrors.resume = "Valid resume link is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setSubmissionStatus("Submitting...");

    axios
      .post(
        "https://api.sheetbest.com/sheets/9302cdac-e5ca-4b88-bbd8-6a31f8f49ac9",
        formData
      )
      .then(() => {
        setFormData({
          name: "",
          email: "",
          fatherName: "",
          dob: "",
          qualification: "",
          phone: "",
          skills: "",
          resume: "",
          message: "",
        });
        setSubmissionStatus("Thank you for applying! We will contact you soon.");
        setTimeout(() => setSubmissionStatus(""), 5000); // Clear status after 5 seconds
      })
      .catch((error) => {
        console.error(error);
        setSubmissionStatus("Something went wrong. Please try again later.");
      });
  };

  return (
    <>
      {/* <Navbar /> */}
      <section className="lg:pl-20 mt-16 bg-gray-100 py-12 selection:bg-purple-700 selection:text-white lg:flex-row items-center px-4 lg:px-24">
        <div className="text-center justify-center font-bold">
        <h1 className="text-4xl font-bold text-purple-700 mb-4">
              Discover Your New Career
            </h1>
        </div>
        <div className="container mx-auto flex flex-col lg:flex-row items-center">
          <div className="lg:w-1/2 text-center lg:text-left">
            {/* <h1 className="text-4xl font-bold text-purple-700 mb-4">
              Discover your new career
            </h1> */}
            <h1 className="hidden lg:block justify-center font-bold py-5 pr-5 text-purple-800 font-serif text-xl">
            At Powergenic Engineering & Technical Expertise, we believe in innovation, excellence, and growth. Our expertise spans across mechanical engineering solutions, delivering cutting-edge technologies that drive industries forward. If you're passionate about engineering, technology, and innovation, explore our exciting career opportunities!


            </h1>
            <p className="text-gray-600 text-lg mb-6">Explore Opportunities</p>
            <div className="flex justify-center lg:justify-start space-x-4">
              <a
                href="#form"
                className="bg-purple-600 text-white px-6 py-2 rounded-md shadow-md hover:bg-purple-700"
              >
                SEARCH JOBS
              </a>
              <a
                href="#"
                className="bg-gray-200 text-purple-600 px-6 py-2 rounded-md shadow-md hover:bg-gray-300"
              >
                RECENTLY VIEWED JOBS
              </a>
            </div>
          </div>
          <div className="lg:w-1/2 mt-4">
            <img src={logo} alt="Logo" className="bg-purple-800 rounded-2xl" />
          </div>
        </div>
      </section>

      {/* <section className="py-12 bg-gray-50 justify-center text-center" id="form">


        <div className="container mx-auto flex flex-col lg:flex-row items-center pl-24">
          <div className="lg:w-1/2 mt-4">
            <img src={jobLogo} alt="Logo" className="w-full max-w-md lg:max-w-full h-auto lg:h-[600px] object-contain rounded-2xl shadow-lg" />
          </div> */}

      <section className="py-12 bg-gray-50 flex justify-center text-center" id="form">
        <div className="container mx-auto flex flex-col lg:flex-row items-center px-4 lg:px-24">
          {/* Job Logo - Hidden on Small Screens */}
          <div className="hidden lg:block lg:w-1/2">
            <img
              src={jobLogo}
              alt="Job Logo"
              className="w-full max-w-md lg:max-w-full h-auto lg:h-[500px] object-contain rounded-2xl shadow-lg"
            />
          </div>



          <div className="container mx-auto">
            <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-lg p-8">
              <h2 className="text-2xl font-bold text-purple-700 mb-6">
                Apply for a Job
              </h2>
              <form onSubmit={handleSubmit}>
                {/* Form Fields */}
                {[
                  { name: "name", label: "Your Name", type: "text" },
                  { name: "email", label: "Your Email", type: "email" },
                  { name: "fatherName", label: "Father's Name", type: "text" },
                  { name: "dob", label: "Date of Birth", type: "date" },
                  { name: "qualification", label: "Qualification", type: "text" },
                  { name: "phone", label: "Phone Number", type: "tel" },
                  { name: "skills", label: "Skills", type: "text" },
                  { name: "resume", label: "Resume Link", type: "url" },
                ].map(({ name, label, type }) => (
                  <div key={name} className="mb-4">
                    <input
                      type={type}
                      name={name}
                      value={formData[name]}
                      onChange={handleChange}
                      placeholder={`${label} *`}
                      className="w-full p-3 border rounded-md focus:outline-purple-600"
                    />
                    {errors[name] && (
                      <span className="text-red-500 text-sm">
                        {errors[name]}
                      </span>
                    )}
                  </div>
                ))}

                {/* Message */}
                <div className="mb-4">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Message"
                    className="w-full p-3 border rounded-md focus:outline-purple-600"
                  ></textarea>
                </div>

                {/* Submission Status */}
                {submissionStatus && (
                  <p className="text-center text-purple-600 mb-4">
                    {submissionStatus}
                  </p>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-purple-600 text-white py-3 rounded-md hover:bg-purple-700 transition duration-200"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* <Footer /> */}
    </>
  );
};

export default Careers;
